import React from 'react';
import PropTypes from 'prop-types';
import { PageLayout } from '~/components/common';

const Organization = ({ routes }) => {
  const sideNavItems = routes.map(r => ({
    label: r.path,
    to: `/organization/${r.path}`,
  }));

  return (
    <PageLayout
      routes={routes}
      sideNavItems={sideNavItems}
    />
  );
};

Organization.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.shape({
    path: PropTypes.string.isRequired,
  })).isRequired,
};

export default Organization;
